@if (type === 'icon-button') {
  <em-button
    type="icon"
    color="basic"
    [icon]="icon"
    [matMenuTriggerFor]="userMenu"
    data-testid="icon-button"
  ></em-button>
}

@if (type === 'button') {
  <em-button
    color="basic"
    [icon]="icon"
    [matMenuTriggerFor]="userMenu"
    data-testid="button"
    ><span class="label">{{ title | translate }}</span>
  </em-button>
}

<mat-menu #userMenu="matMenu">
  <ng-content select="[header]"></ng-content>

  @for (item of menuItems; track item) {
    @if (!item?.external) {
      <a
        mat-menu-item
        [routerLink]="item?.targetPath"
        [queryParams]="item?.queryParams"
        >
        <span>{{ item?.title | translate }}</span>
      </a>
    }
    @if (item?.external) {
      <a
        mat-menu-item
        [href]="item?.targetPath"
        emExternalLink
        >
        <span>{{ item?.title | translate }}</span>
      </a>
    }
  }

  <ng-content></ng-content>
</mat-menu>
